import { useState } from 'react'
import { Form, Table, Footer } from './Components'
import Title from '../../components/Title/index'
import styles from './styles.module.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Button from '../../components/Button'
import Modal from 'react-responsive-modal'
import ScheduleSettings from '../ScheduleSettings'
import { getScheduleSettingsTeachersSubjects } from '../../actions/scheduleSettings'
import { MdRefresh } from 'react-icons/md'
import { RiFileExcel2Fill } from 'react-icons/ri'

const Scheduling = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const goHome = () => navigate('/')

  const [settingsOpen, setSettingsOpen] = useState(false)

  const openSettings = () => {
    dispatch(getScheduleSettingsTeachersSubjects({}))
    setSettingsOpen(true)
  }

  return (
    <div className={styles.wrapper}>
      <Title title="Составление расписания" />
      <Form />

      <div className={styles.contentArea}>
        <div className={styles.tableArea}>
          <Table />
        </div>

        <div className={styles.sidebar}>
          <div className={styles.sidebarGroup}>
            <Button className={styles.sidebarBtn} mode='white'>
              <MdRefresh size={15} />
              Обновить
            </Button>
            <Button className={styles.sidebarBtn} mode='white'>
              <RiFileExcel2Fill size={15} color='#217346' />
              Импорт из Excel
            </Button>
            <Button className={styles.sidebarBtn} mode='white'>
              <RiFileExcel2Fill size={15} color='#217346' />
              Экспорт в Excel
            </Button>
          </div>

          <div className={styles.sidebarGroup}>
            <Button className={styles.sidebarBtn}>Составить</Button>
            <Button className={styles.sidebarBtn} mode='white'>Проверить ошибки</Button>
          </div>
        </div>
      </div>


      <Modal
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        closeOnEsc
        classNames={{ modal: styles.settingsModal }}
      >
        <ScheduleSettings />
      </Modal>
      <Footer goHome={goHome} onSettings={openSettings} />
    </div>
  )
}

export default Scheduling
